import React, {useEffect} from 'react'

const Dashboard = () => {
    useEffect(() => {
        window.location.href = "https://dashboard.causalfunnel.com/"
    }, [])
  return (
    <div></div>
  )
}

export default Dashboard